module.exports = __webpack_public_path__ + "static/sigma-2-6fb6d37cb5e2c6e691f6ce3879422a04.jpeg";